export default __webpack_public_path__ + "static/media/greenTick.4c7fab1b.svg";